import { render, staticRenderFns } from "./Billings.vue?vue&type=template&id=270cece1"
import script from "./Billings.vue?vue&type=script&lang=js"
export * from "./Billings.vue?vue&type=script&lang=js"
import style0 from "./Billings.vue?vue&type=style&index=0&id=270cece1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports